var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"circle_icon",attrs:{"title":_vm.title}},[_c('img',{staticStyle:{"width":"40px","height":"40px"},attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }